import { createSlice, PayloadAction, createAsyncThunk} from "@reduxjs/toolkit"
import { CurrentPartyEventState } from '../currentPartyEvent/currentPartyEventSlice'
import { CurrentEventUserState } from "../addEventUser/currentEventUserSlice"
import { AcceptInvitationDto, insertInvitationAsync, insertInvitationAcceptanceAsync, SaveInvitationDto } from "./invitationAPI"
import { RootState } from "../../app/store"
import { saveState } from '../../utils/browserStorage';

export interface InvitationState {
    invitationReference: string
    status: 'idle' | 'loading' | 'failed'
}

const initialState : InvitationState = {
    invitationReference: '',
    status: 'idle'
}

export interface SaveInvitationRequest {
    token: string
  }

export interface AcceptInvitationRequest {
  token: string,
  email: string
}

export const addInvitationAsync = createAsyncThunk(
    'invitation/addInvitation',
    async (request: SaveInvitationRequest , { getState }) => {
      const { currentEventUser } = getState() as { currentEventUser: CurrentEventUserState}
      const { currentPartyEvent } = getState() as { currentPartyEvent: CurrentPartyEventState}
      let saveInvitationDto: SaveInvitationDto = {
        partyEventId: currentPartyEvent.partyEvent?.id ??0,
        email: currentEventUser.userEmail
        
      }
      const response = await insertInvitationAsync(saveInvitationDto, request.token)
      return response
    }
  )

export const acceptInvitationAsync = createAsyncThunk(
  'invitation/acceptInvitation',
  async (request: AcceptInvitationRequest, { getState }) => {
    const { invitation } = getState() as { invitation: InvitationState}
    let acceptInvitationDto: AcceptInvitationDto = {
      reference: invitation.invitationReference,
      actualEmail: request.email
    }
    const response = await insertInvitationAcceptanceAsync(acceptInvitationDto, request.token)
    return response
  }
)

export const invitationSlice = createSlice({
    name: 'invitation',
    initialState: initialState,
    reducers: {
        setInvitationReference: (state, action: PayloadAction<string>) => {
            state.invitationReference = action.payload
            saveState('invitation', state);
          }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
      builder
        .addCase(acceptInvitationAsync.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(acceptInvitationAsync.fulfilled, (state, action) => {
          state.status = 'idle';
          state.invitationReference = ''
        })
        .addCase(acceptInvitationAsync.rejected, (state) => {
          state.status = 'failed';
          state.invitationReference = ''
        });
    }
})



export const { setInvitationReference } = invitationSlice.actions 
export const  selectInvitationReference = (state: RootState ) => state.invitation.invitationReference
export default invitationSlice.reducer